import * as React from 'react';
import { TextField } from "@mui/material";
import { useEffect, useState } from 'react';
import { ApiRequest } from "GlobalFunctions";
import LoadingButton from '@mui/lab/LoadingButton';
import Box from "elements/Box";
import ImageUploader from "elements/ImageUploader";
import OrdersUsers from './OrdersUsers';

const defaultValues = {
    user_id: null,
    name: '',
    lastname: '',
    email: '',
    password: '',
    role_id: 1, // Valor predeterminado
    phone: '',
    is_active: false,
    deleted: false,
    image: '',
}

export default function AccountUsers(props: any) {

    const [formValues, setFormValues] = useState(defaultValues);
    const [loadingButton, setLoadingButton] = useState(false);

    const loadDetails = async () => {
        await ApiRequest({
            url: '/users/details',
            method: 'GET',
            setResponse: (response: any) => {
                setFormValues(response); 
            }
        });
    }

    useEffect(() => {
        loadDetails();
    }, []);

    /*=============================================
    UPDATE ACCOUNT
    =============================================*/
    const submit = async () => {

        const body = new FormData();
        body.append('formValues', JSON.stringify(formValues));

        if (files) {
            body.append("image", files);
        }


        setLoadingButton(true);
        await ApiRequest({
            url: '/users/updateAccount',
            method: 'POST',
            formData: true,
            body: body,
            setResponse: (response: any) => {
                setLoadingButton(false);
            }
        });
    }

    const validateEmail = (email: string) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(String(email).toLowerCase());
    }

    const [files, setFiles] = useState<any>([]);

    return (
        <div id='account_users_container' className="content">
            <Box className='intent-auth_component'>


                <div className='section_flex'>

                    <ImageUploader 
                        className="user_image"
                        image={formValues.image} 
                        setImage={(newImage) => setFormValues({ ...formValues, image: newImage })}
                        setFiles={setFiles} 
                    />

                    <div className='account_right'>
                        <div className='input_group'>
                            <div className='input_row'>
                                <TextField
                                    label="Nombre"
                                    value={formValues.name}
                                    onChange={(e) => setFormValues({ ...formValues, name: e.target.value })}
                                    variant="outlined"
                                    fullWidth
                                />

                                <TextField
                                    label="Apellido"
                                    value={formValues.lastname}
                                    onChange={(e) => setFormValues({ ...formValues, lastname: e.target.value })}
                                    variant="outlined"
                                    fullWidth
                                />
                            </div>

                            <div className="input_row">
                                <TextField
                                    label="Número de Teléfono"
                                    value={formValues.phone}
                                    onChange={(e) => setFormValues({ ...formValues, phone: e.target.value })}
                                    variant="outlined"
                                    fullWidth
                                />

                                <TextField
                                    label="Correo Electrónico"
                                    value={formValues.email}
                                    onChange={(e) => setFormValues({ ...formValues, email: e.target.value })}
                                    error={formValues.email !== '' && !validateEmail(formValues.email)}
                                    helperText={formValues.email !== '' && !validateEmail(formValues.email) ? 'Correo inválido' : ''}
                                    variant="outlined"
                                    fullWidth
                                />
                            </div>
                        </div>
                    </div>

                </div>
                

                <div className="input_group">
                    <LoadingButton
                        size="small"
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ fontSize: '13px', padding: '10px 0px' }}
                        onClick={submit}
                        loading={loadingButton}
                    >
                        Guardar
                    </LoadingButton>
                </div>
            </Box>

            <OrdersUsers />
         
        </div>

        
    );
}
